import { Fraction } from 'bi-fraction';
import { AbiCoder } from 'ethers';
import { BondingCurve as BondingCurveAbi } from '../abis';
import { FUN_TOKEN_DECIMALS, LAUNCH_TOKEN_FEE_AGENTFUN } from '../constants';
import { getContract } from '../utils';
import { approveIfRequired } from '../utils/approveIfRequired';
import { executeTx } from '../utils/executeTx';
import { getInitialSupplyReceiveAmount } from '../utils/getInitialSupplyReceiveAmount';
import { isSigner } from '../utils/isSigner';
export class AgentLauncher {
    constructor(options) {
        this.options = options;
    }
    get bondingCurve() {
        return getContract(this.options.addresses.BondingCurve, BondingCurveAbi, this.options.signerOrProvider);
    }
    async launchToken(name, ticker, description, image, urls, purchaseAmount, cores = [0, 1, 2]) {
        if (!isSigner(this.options.signerOrProvider))
            throw new Error('need signer for launchToken function');
        const purchaseAmountInBn = purchaseAmount.shl(FUN_TOKEN_DECIMALS).quotient;
        const purchasePlusFeeBn = purchaseAmountInBn +
            new Fraction(LAUNCH_TOKEN_FEE_AGENTFUN).shl(FUN_TOKEN_DECIMALS).quotient;
        await approveIfRequired(this.options.addresses.AgentFun, this.options.addresses.BondingCurve, purchasePlusFeeBn, this.options.signerOrProvider);
        const tx = this.bondingCurve.launch(name, ticker, cores, description, image, urls, purchasePlusFeeBn);
        const receipt = await executeTx(tx);
        const logs = receipt?.logs;
        const tokenAddress = this.getTokenAddressFromLogs(logs);
        return { receipt, tokenAddress };
    }
    async getInitialSupplyReceiveAmount(purchaseAmount) {
        const assetRate = await this.bondingCurve.assetRate();
        return getInitialSupplyReceiveAmount(purchaseAmount, assetRate);
    }
    // compare PairCreated event such as https://explorer.zkevm.cronos.org/testnet/tx/0x210234bb7b65aa0e505bd2a20af323b3a635267ab504fdb40bae0f6dc112f4a1#eventlog
    getTokenAddressFromLogs(logs) {
        if (!logs)
            return undefined;
        for (const log of logs) {
            if (log.topics[0].toLowerCase() === AgentLauncher.PAIR_CREATED_EVENT_HASH) {
                const token0 = new AbiCoder().decode(['address'], log.topics[1])[0];
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return token0;
            }
        }
        return undefined;
    }
}
AgentLauncher.PAIR_CREATED_EVENT_HASH = '0x0d3648bd0f6ba80134a33ba9275ac585d9d315f0ad8355cddefde31afa28d0e9';
